<template>
  <b-modal id="giftCardSelectionModal" centered scrollable size="lg"
    header-class="text-center w-100">
    <div slot="modal-title" align="center" class="w-100">
      <h4 class="ticket-selection-header">
        Buy Gift Card
      </h4>
    </div>

    <b-row>
      <b-col md="8" sm="12">
        <h5 class="media-heading">
          <i class="fa fa-gift" aria-hidden="true"></i>
          {{ giftCard.title }}
        </h5>
      </b-col>

      <b-col md="4" sm="12">
        <b-row>
          <b-col>
            <select class="form-control ui-select" v-model="selectedPrice"
              @change="handleSelect"
            >
              <option :key="2500"
                      :value="2500">
                $25
              </option>
              <option :key="5000"
                      :value="5000">
                $50
              </option>
              <option :key="10000"
                      :value="10000">
                $100
              </option>
              <option :key="25000"
                      :value="25000">
                $250
              </option>
              <option :key="50000"
                      :value="50000">
                $500
              </option>
              <option :key="'Custom'"
                      :value="'Custom'">
                Custom
              </option>
            </select>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="mt-2">
            <b-input-group v-if="showCustomPrice" prepend="$" class="mb-2 mr-sm-2 mb-sm-0">
              <input v-model="customPrice"
                @change="handleCustomPrice"
                class="form-control"
                type="number"
                lang="en"
                min="25"
                max="500"
                step="0.01"
                placeholder="25-500">
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <div slot="modal-footer" class="w-100">
      <div class="row">
        <div class="col-lg-8 col-md-5 col-sm-6 col-xs-12">
          <h5 v-if="giftCard.limited_time_bonus_enabled && !giftCard.limited_time_bonus_out_of_date">
            Total: ${{ parseFloat(price / 100).toFixed(2) }} + {{ giftCard.bonus_percentage}}% bonus =
              <strong> ${{ totalWithBonusPrice() }} </strong>
          </h5>

          <h5 v-else>
            Total: <strong>${{ price / 100 }}</strong>
          </h5>
        </div>

        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 my-auto">
          <b-button variant="primary" class="btn-block float-right" @click="validate()">
            Checkout
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'GiftCardSelectionModal',
  data: function () {
    return {
      price: 2500,
      customPrice: undefined,
      selectedPrice: 2500,
      showCustomPrice: false
    }
  },
  props: {
    giftCard: {
      required: true,
      type: Object
    }
  },
  methods: {
    validate () {
      if (this.price > 0) {
        this.goToCheckout()
      } else {
        this.$swal({
          title: 'Please, select one gift card price',
          type: 'warning'
        })
      }
    },
    goToCheckout () {
      this.$router.push({
        name: 'giftCardPurchase',
        params: {
          id: this.giftCard.id,
          gift_card: this.giftCard,
          price: this.price
        }
      })
    },
    handleSelect () {
      if (this.selectedPrice === 'Custom') {
        this.showCustomPrice = true
        this.price = 2500
      } else if (Number.isInteger(this.selectedPrice)) {
        this.showCustomPrice = false
        this.price = this.selectedPrice
      }
    },
    handleCustomPrice () {
      if (this.customPrice) {
        this.customPrice = Math.max(Math.min(parseFloat(this.customPrice).toFixed(2), 500), 25).toFixed(2)
        this.price = this.customPrice * 100
      }
    },
    totalWithBonusPrice () {
      return (this.calculateBonusPrice(this.price, this.giftCard.bonus_percentage) + (this.price / 100)).toFixed(2)
    }
  }
}
</script>
